import clsx from 'clsx';

import { Icon } from '@gitbook/spine-icons';

import { Button } from '../Button';

export function CardDismissButton(props: { onDismiss: () => void }) {
    return (
        <Button
            iconOnly
            kind="blank"
            size="small"
            label="Dismiss"
            leadingIcon={Icon.X}
            onPress={props.onDismiss}
            className={clsx(
                'absolute top-1 right-1 z-10 opacity-0 transition-opacity group-hover/card:opacity-100'
            )}
        />
    );
}
